import React, { useEffect, useState } from "react";
import MyRouts from "./routers/routes";
import Header from "./components/HeaderSection/Header";
import { useDispatch, useSelector } from "react-redux";
import { updateLanguageRS } from "./redux/reduxActions/reduxStoreActions";
import i18n from "i18n-js";
import { BrowserRouter as Router } from "react-router-dom";
import LoginComponent from "./components/AppComponents/LoginComponent";
import LoginLinkComponent from "./components/AppComponents/LoginLinkComponent";
import Loader from "./components/Loader/Loader";
import HostnameRedirect from "./routers/HostnameRedirect";
import HeaderBE from "./components/HeaderSection/HeaderBE";
import {appLanguage, WEBSITE_TYPE} from "./config/Constants";
import BERouts from "./routers/routes-be";
import {UsercentricsScript, UsercentricsProvider} from '@s-group/react-usercentrics'
import KlaroLoader from "./GDPR/KlaroLoader";


export default function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [timer, setTimer] = useState(() => {
    const storedTimer = parseInt(localStorage.getItem('timer'), 10);
    return !isNaN(storedTimer) ? storedTimer : 60;
  });

  const dispatch = useDispatch();

  let appLanguageRS = useSelector((state) => state.appLanguageRS);

  i18n.locale = appLanguageRS;


  useEffect(() => {
    if (!appLanguageRS) {
      const baseDomain = window.location.hostname.toLowerCase();
      let detectedLanguage = process.env.REACT_APP_WEBSITE;
      if (baseDomain.includes("knaek.com")) {
        detectedLanguage =  appLanguage.en;
      } else if (baseDomain.includes("knaek.nl")) {
        detectedLanguage = appLanguage.nl;
      } else if (baseDomain.includes("knaek.be")) {
        detectedLanguage =  appLanguage.be; // Handle the 'be' website
      }// Update i18n and Redux state
      i18n.locale = detectedLanguage;
      dispatch(updateLanguageRS(detectedLanguage));
    } else {
      i18n.locale = appLanguageRS;
    }
  }, [appLanguageRS, dispatch]);

  const emailInModalRS = useSelector((state) => state.emailInModalRS);

  useEffect(() => {
    let interval;
    if (emailInModalRS) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer > 0) {
            return prevTimer - 1;
          } else {
            clearInterval(interval);
            return 0;
          }
        });
      }, 1000);
    } else {
      // Clear the timer interval when the modal is closed
       clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [emailInModalRS]);

  // Update localStorage with timer value whenever it changes
  useEffect(() => {
    localStorage.setItem('timer', timer);
  }, [timer]);

  useEffect(() => {
    setTimeout(function(){
        setIsLoading(false);
    },1000)
  }, []);

  return (
    <div>
      <UsercentricsScript settingsId={process.env.REACT_APP_COCKIE}/>
      <UsercentricsProvider>
      { isLoading &&
        <Loader />
      }
      <HostnameRedirect />
      <KlaroLoader />

      <Router>
        {WEBSITE_TYPE === appLanguage.nl ? (
            <Header
                switchLanguage={switchLanguage}
                imageData="img/knaek/logo_nl.png"
            />
        ) : (
            <HeaderBE switchLanguage={switchLanguage}/>
        )}
        <div id="scrollUp" title="Scroll To Top">
          <i className="fas fa-arrow-up" />
        </div>
        {WEBSITE_TYPE === appLanguage.nl ? (
            <MyRouts />
        ) : (
            <BERouts/>
        )}

        <LoginComponent />
        <LoginLinkComponent timer={timer} setTimer={setTimer} />
        {/*<SMPixelNotificationComponent timer={timer} setTimer={setTimer} />*/}
      </Router>
      </UsercentricsProvider>
    </div>
  );

  function switchLanguage(language) {
    document.querySelector('.navbar').classList.remove('active')
    document.querySelector('body').classList.remove('canvas-open')
    document.querySelector('.navbar-toggler-icon').classList.remove('active')
    dispatch(updateLanguageRS(language));
  }
}
